module.exports = __webpack_public_path__ + "static/NTKA_Logo-removebg-414dab6c9aecc15cad719090b704879a.png";